export enum UploadTypes {
    CoverLetter = "CoverLetter",
    ProfilePhoto = "ProfilePhoto",
    CV = "CV",
    Other = "Other"
}

export enum UploadTypesInt {
    CoverLetter = 2,
    ProfilePhoto = 4,
    CV = 1,
    Other = 6
}